const carouselItems = [
  {
    title: '国产科幻崛起之路',
    desc: '从《流浪地球》到《三体》，中国科幻影视正以惊人速度追赶世界顶尖水平，探索属于东方的宇宙叙事。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cityscape%20with%20towering%20structures%20and%20neon%20lights%2C%20spaceships%20in%20sky%2C%20warm%20golden%20sunset%20atmosphere%2C%20cinematic%20wide%20shot%2C%20epic%20scale%2C%20professional%20movie%20poster%20quality&width=600&height=340&seq=carousel-card-01&orientation=landscape',
    tag: '专题',
  },
  {
    title: '日漫新番推荐指南',
    desc: '本季最值得追的日漫新番大盘点，热血、治愈、悬疑各类型全覆盖，追番不迷路。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20illustration%20with%20diverse%20characters%20in%20dynamic%20action%20poses%2C%20vibrant%20cherry%20blossom%20background%2C%20Japanese%20animation%20aesthetic%2C%20warm%20and%20energetic%20composition%2C%20professional%20anime%20key%20visual%20style&width=600&height=340&seq=carousel-card-02&orientation=landscape',
    tag: '专题',
  },
  {
    title: '古装剧美学大赏',
    desc: '盘点近年古装剧中的顶级服化道设计，从唐风汉韵到清宫典雅，每一帧都是视觉盛宴。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20costume%20drama%20scene%20with%20flowing%20silk%20robes%20and%20intricate%20hair%20ornaments%2C%20ancient%20palace%20interior%20with%20warm%20candlelight%2C%20soft%20golden%20tones%2C%20cinematic%20composition%2C%20refined%20and%20graceful%20atmosphere&width=600&height=340&seq=carousel-card-03&orientation=landscape',
    tag: '专题',
  },
  {
    title: '综艺爆笑名场面',
    desc: '收集各大热门综艺中的经典搞笑片段，从游戏挑战到即兴表演，笑到停不下来。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20and%20colorful%20variety%20show%20stage%20with%20confetti%20and%20cheerful%20atmosphere%2C%20dynamic%20game%20show%20setting%2C%20vibrant%20studio%20lighting%20with%20warm%20and%20playful%20tones%2C%20professional%20entertainment%20photography&width=600&height=340&seq=carousel-card-04&orientation=landscape',
    tag: '合集',
  },
  {
    title: '悬疑烧脑片单',
    desc: '结局绝对猜不到的高分悬疑片推荐，从国产经典到海外佳作，挑战你的推理极限。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20noir%20style%20scene%20with%20shadowy%20alley%20and%20single%20streetlamp%2C%20foggy%20urban%20night%20atmosphere%2C%20dramatic%20chiaroscuro%20lighting%2C%20suspenseful%20cinematic%20composition%2C%20film%20noir%20aesthetic%20with%20deep%20contrast&width=600&height=340&seq=carousel-card-05&orientation=landscape',
    tag: '片单',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-gray-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">精选专题</h2>
            <p className="text-sm text-gray-500 mt-2">深度内容，发现更多精彩视角</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.map((item, idx) => (
              <article key={idx} className={`bg-white rounded-xl border border-gray-100 overflow-hidden hover:border-gray-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer ${
                idx === 0 ? 'lg:col-span-2' : ''
              }`}>
                <div className={`relative ${idx === 0 ? 'aspect-[16/7]' : 'aspect-[16/9]'} bg-gray-100 overflow-hidden`}>
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 bg-black/60 text-white text-xs font-medium px-2.5 py-1 rounded-full backdrop-blur-sm whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}